import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessFinderService } from './business-finder.service';
import { FboResult } from '../models/fbo-result.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
/**
 * HTTP service for the Business Finder (FBOs). Calls the AirportsAPI `~/fbos` endpoint. Category facet
 * filtering (Amenities / Facilities / Fuel / Line Services / ...) is applied client-side in
 * {@link SearchPageComponent}; this service performs only the location/state/keyword query.
 */
var FbosService = /** @class */ (function (_super) {
    tslib_1.__extends(FbosService, _super);
    function FbosService(http, errorHandler) {
        var _this = _super.call(this, http, errorHandler) || this;
        _this.endpoint = 'fbos';
        return _this;
    }
    FbosService.prototype.parse = function (data) {
        return FboResult.parse(data);
    };
    FbosService.prototype.getFbosByLatLon = function (latlon, radius) {
        return this.getByLatLon(latlon, radius);
    };
    FbosService.prototype.getFbosByBoundingBox = function (bounds) {
        return this.getByBoundingBox(bounds);
    };
    FbosService.prototype.getFbosByState = function (state) {
        return this.getByState(state);
    };
    FbosService.prototype.getFbosBySearchTerm = function (term) {
        return this.getBySearchTerm(term);
    };
    FbosService.ngInjectableDef = i0.defineInjectable({ factory: function FbosService_Factory() { return new FbosService(i0.inject(i1.HttpClient), i0.inject(i0.ErrorHandler)); }, token: FbosService, providedIn: "root" });
    return FbosService;
}(BusinessFinderService));
export { FbosService };
